import { pushToDataLayer } from '@/utils/dataLayer'
import { useDataLayerHelpers } from '@/composables/data-layers/useDataLayerHelpers'

interface IEventCardDataLayer {
  event_category: string
  event_action: string
}

export const useEventCardDataLayer = () => {
  const { locale } = useI18n()
  const dataLayerHelpers = useDataLayerHelpers()

  const pushEventCardDataLayer = (data: IEventCardDataLayer) => {
    const eventData = {
      event: 'investor_events',
      site_language: locale.value,
      page_type: dataLayerHelpers.getPageType(),
      ...data
    }
    pushToDataLayer(eventData)
  }

  return { pushEventCardDataLayer }
}
